import { Suspense, useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router";
import cn from "classnames";
import { AnnouncementBanner, Header, Sidebar } from "@/shared/components";
import { BreadcrumbProvider, useAppSelector } from "@/shared/hooks";
import { clearMemoryDrafts, HOME_PAGE_ROUTE } from "@/shared/utils";
import { selectSidebarCollapsed } from "@/features/settings";

export default function PrivateLayout() {
  const isCollapsed = useAppSelector(selectSidebarCollapsed);
  const { pathname } = useLocation();
  const prevPathnameRef = useRef(pathname);

  useEffect(function clearMemoryDraftsOnRouteChange() {
    if (prevPathnameRef.current !== pathname) {
      prevPathnameRef.current = pathname;
      clearMemoryDrafts();
    }
  }, [pathname]);

  return (
    <BreadcrumbProvider>
      <div className="surface-base-fill h-screen overflow-hidden">
        <Sidebar />
        <main
          className={cn(
            "flex flex-col h-screen transition-[padding-left] duration-300 ease-in-out",
            isCollapsed ? "pl-[88px]" : "pl-[280px]",
          )}>
          <AnnouncementBanner
            dismissKey="tax-policy-banner-dismissed"
            textKey="taxPolicyNotice.title"
            additionalTextKey="taxPolicyNotice.text"
          />
          <div className="flex-1 min-h-0 flex flex-col p-2">
            <div className="flex-1 min-h-0 flex flex-col surface-secondary-fill radius-2xl p-4">
              {pathname !== HOME_PAGE_ROUTE && <Header />}
              <div className="flex-1 min-h-0 flex flex-col overflow-y-auto overflow-x-hidden page-scroll pl-px">
                <Suspense fallback={null}>
                  <Outlet />
                </Suspense>
              </div>
            </div>
          </div>
        </main>
      </div>
    </BreadcrumbProvider>
  );
}

